<script setup lang="ts">
defineOptions({
  name: 'AppFooter',
});
</script>

<template>
  <footer class="bg-gray-100 py-6 mt-auto">
    <div class="container mx-auto px-4">
      <div class="flex justify-center items-center space-x-6 text-sm text-gray-600">
        <a href="https://shotmetrics-ai.com/privacy" class="hover:text-gray-900 transition-colors">
          Privacy Policy
        </a>
        <span class="text-gray-400">|</span>
        <a href="https://shotmetrics-ai.com/terms" class="hover:text-gray-900 transition-colors">
          Terms of Service
        </a>
      </div>
      <div class="text-center mt-4 text-sm text-gray-500">
        © {{ new Date().getFullYear() }} SHOTMETRICS AI. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
